import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Radix Select ve bazı UI bileşenleri masumca "ResizeObserver loop completed
// with undelivered notifications" hatası atıyor. Bu, tarayıcının bildirdiği
// bir spec uyarısı; runtime problemi değil. CRA dev overlay bunu yakalayıp
// büyük kırmızı hata ekranı gösteriyor. Susturuyoruz.
const RESIZE_OBSERVER_ERROR_MSG = /ResizeObserver loop (completed|limit)/i;
window.addEventListener("error", (e) => {
  if (e && e.message && RESIZE_OBSERVER_ERROR_MSG.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e && e.reason && (e.reason.message || String(e.reason));
  if (msg && RESIZE_OBSERVER_ERROR_MSG.test(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
